import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewProjectApiComponent } from '../component/page/new-project-api/new-project-api.component';
import { AuthGuardService } from '../service/auth-guard.service';
import { Ndc21ApiReferenceComponent } from '../component/page/ndc-21-api-reference/ndc-21-api-reference.component';

const routes: Routes = [
    { path: 'ndcportal', redirectTo: '/new-project-api', pathMatch: 'full' },
    { path: 'ndcportal/sandbox', redirectTo: '/new-project-api', pathMatch: 'full' },
    { path: 'ndcportal/api-docs', redirectTo: '/21.3-api-docs', pathMatch: 'full' },
    { path: 'new-project-api', component: NewProjectApiComponent, canActivate: [AuthGuardService]},
    { path: '21.3-api-guide', component: Ndc21ApiReferenceComponent, canActivate:[AuthGuardService] }
  ] 

@NgModule({
        imports: [RouterModule.forRoot(routes)],
        exports: [RouterModule]
      })
export class AppNewSandboxRoutingModule {}    
